<template>
    <footer>
        <ul class="news-link">
            <li @click="about">关于有乐</li>
            <li @click="contactUs">联系我们</li>
            <li @click="userAgreement">用户协议</li>
            <li @click="descContribution">投稿说明</li>
            <li @click="copyRight">版权声明</li>
            <li>客服中心</li>
            <li @click="feedBack">反馈留言</li>
        </ul>
        <div class="toggle-device">
            <span class="ft-red">电脑版</span>
            <span class="ft-gray">触屏版</span>
        </div>
        <p>Copyright &copy;{{new Date().getFullYear()}} iyoule.com All rights reserved</p>
        <p><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010402000331" target="_blank">苏ICP备16033847号-2</a></p>
        <p>请所有作者发布作品时务必遵守国家互联网信息管理办法规定，我们拒绝任何色情小说， 已经发现，即作删除</p>
        <p>本站所收录作品、社区话题、书库评论及本站所做之广告均属其个人行为，与本站立场无关</p>
    </footer>
</template>

<script>
  export default ({
      data () {
          return {
              msg: 'aa'
          }
      },
      methods: {
          //这些都应该由后台生成，暂时写死
          about () {
              this.$router.push(`/news/4/all`)
          },
          contactUs () {
              this.$router.push(`/news/4/18`)
          },
          userAgreement() {
              this.$router.push(`/news/4/19`)
          },
          descContribution () {
              this.$router.push(`/news/5/21`)
          },
          copyRight () {
              this.$router.push(`/news/4/20`)
          },
          feedBack () {
              window.open(`http://www.iyoule.com/message.php?action=addcommunview`)
          }
      }
  })
</script>

<style lang="less" scoped>
    footer {
        text-align: center;
        margin-top: 2rem;
        font-size: 12px;
        background: #414249;
        padding: 10px 0;
        .news-link {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            li {
                color: #ffffff;
                font-size: 13px;
                line-height: 1;
                padding: 0 14px;
                margin: 8px 0;
                cursor: pointer;
            }
            li + li {
                border-left: 1px solid #ffffff;
            }
        }
        .toggle-device {
            margin: 10px auto;
            span {
                padding: 14px;
            }
        }
        p, p>a {
            color: #abaec6;
        }

    }
</style>
